import React, { Component } from 'react';
import config from '../config'
import {myNumberFormat, nl2br} from "../utils/Utils";

let format = require('date-fns/format')
let de = require('date-fns/locale/de')

// Right Col
let DateFromTo = (props) => {
    let event = props.event

    let month = format(new Date(event.startdatum), 'MMMM', {locale: de})
    let dayName = format(new Date(event.startdatum), 'dddd', {locale: de})
    let day = format(new Date(event.startdatum), 'DD')
    let year = format(new Date(event.startdatum), 'YYYY')

    let DateFromToRow = []

    if (event.status !== 3) {
        DateFromToRow.push(dayName)
        DateFromToRow.push(day + '.')
    }
    DateFromToRow.push(month)
    DateFromToRow.push(year)

    if (event.enddatum) {
        let endMonth = format(new Date(event.enddatum), 'MMMM', {locale: de})
        let endDayName = format(new Date(event.enddatum), 'dddd', {locale: de})
        let endDay = format(new Date(event.enddatum), 'DD')
        let endYyear = format(new Date(event.enddatum), 'YYYY')

        DateFromToRow.push('-')
        DateFromToRow.push(endDayName)
        DateFromToRow.push(endDay+'.')
        DateFromToRow.push(endMonth)
        DateFromToRow.push(endYyear)
    }

    if (event.status === 3) {
        DateFromToRow.push('(vorrausichtlich)')
    }

    return <span>
        {DateFromToRow.join(' ')}
    </span>
}

let TimeFromTo = (props) => {
    let event = props.event
    let TimeFromToRow = []

    if (event.startzeit) {
        TimeFromToRow.push('Uhrzeit:')
        TimeFromToRow.push(event.startzeit)
    }

    if (event.endzeit) {
        TimeFromToRow.push('-')
        TimeFromToRow.push(event.endzeit)
    }

    if (TimeFromToRow.length === 0) {
        return null
    }

    return <div>
        {TimeFromToRow.join(' ')} Uhr
    </div>
}

let SigninDeadline = (props) => {
    let event = props.event

    if (!event.anmeldefrist) {
        return null;
    }

    let month = format(new Date(event.anmeldefrist), 'MMMM', {locale: de})
    let dayName = format(new Date(event.anmeldefrist), 'dddd', {locale: de})
    let day = format(new Date(event.anmeldefrist), 'DD')
    let year = format(new Date(event.anmeldefrist), 'YYYY')

    let DateFromToRow = []

    DateFromToRow.push(dayName)
    DateFromToRow.push(day + '.')
    DateFromToRow.push(month)
    DateFromToRow.push(year)

    return <span>
        Anmeldefrist: {DateFromToRow.join(' ')}
    </span>
}

let Teilnehmer = (props) => {
    let event = props.event

    if (!event.teilnehmer_max) {
        return null;
    }

    return <div>
        Insgesamt verfügbar: { event.teilnehmer_max } Plätze
    </div>
}

let Ansprechpartner = (props) => {
    let kreisverband = props.kreisverband

    if (!kreisverband) {
        return null
    }

    return <div>
        <hr />
        <div><strong>Ansprechpartner:</strong></div>
        <div>{kreisverband.art} {kreisverband.dienststelle}</div>
        { kreisverband.telefon && <div>Tel.: {kreisverband.telefon}</div> }
        { kreisverband.mail && <div><a href={'mailto:'+kreisverband.mail}>{kreisverband.mail}</a></div> }
    </div>
}

let Veranstaltungsort = (props) => {
    let raum = props.raum

    if (!raum) {
        return null
    }

    let ort = false
    if (raum.plz && raum.ort) {
        ort = raum.plz+' '+raum.ort
    } else if (raum.ort) {
        ort = raum.ort
    }

    return <div>
        <hr />
        <div><strong>Veranstaltungsort:</strong></div>
        { raum.name && <div>{raum.name}</div> }
        { raum.strasse && <div>{raum.strasse}</div> }
        { raum.ortsteil && <div>{raum.ortsteil}</div> }
        { ort && <div>{ort}</div> }
        { raum.telefon && <div><strong>Tel.:</strong>: {raum.telefon}</div> }
        { raum.fax && <div><strong>Fax:</strong>: {raum.fax}</div> }
        { raum.email && <div><a href={'mailto:'+raum.email}>{raum.email}</a></div> }
        { raum.web && <div><a target={'_blank'} href={'http://'+raum.web}>{raum.web}</a></div> }
    </div>
}

let Gebuehr = (props) => {
    let event = props.event;

    let gebNM = event.gebuehr_nichtmitglieder + event.gebuehr_verpflegung;
    let gebM = event.gebuehr_mitglieder + event.gebuehr_verpflegung;

    if (event.kostenlos === 0 && (gebNM > 0 || gebM > 0)) {
        return <div>
            <hr />
            <div>
                <div>
                <strong>Teilnehmergebühr: </strong>
                    { gebNM > 0 && <span>{myNumberFormat(gebNM)} Euro</span> }
                </div>
                { gebM > 0 && gebM != gebNM && <div><span>(Mitglieder: {myNumberFormat(gebM)} Euro)</span></div> }
            </div>

            { event.gebuehr_bemerkung && <div>
                <hr />
                <div><strong>Bemerkung zur Gebühr: </strong></div>
                <div>{event.gebuehr_bemerkung}</div>
            </div> }
        </div>
    }

    if (event.kostenlos === -1) {
        return <div>
            <hr />
            <div><strong>Teilnehmergebühr: </strong>Die Teilnahme ist kostenlos.</div>
        </div>
    }

    if (event.gebuehr_bemerkung) {
        return <div>
            <hr />
            <div><strong>Bemerkung zur Gebühr: </strong></div>
            <div>{event.gebuehr_bemerkung}</div>
        </div>
    }

    return null
}

let Anmeldung = (props) => {
    let event = props.event;

    let anmeldungUrl = config.anmeldungBaseUrl+event.id;

    let gebNM = event.gebuehr_nichtmitglieder + event.gebuehr_verpflegung;
    let gebM = event.gebuehr_mitglieder + event.gebuehr_verpflegung;

    if (event.kostenlos === 0 && event.reise !== 1 && event.status === 1 && (gebNM > 0 || gebM > 0)) {
        anmeldungUrl = config.anmeldungShopBaseUrl+event.id;
    }

    let anmeldefristInFuture = false;
    let anmeldefristDate = null;

    if (event.anmeldefrist !== null) {
        anmeldefristDate = new Date(event.anmeldefrist + 'T23:59:59');
    } else {
        anmeldefristInFuture = true;
    }

    Date.prototype.subHours= function(h){
        this.setHours(this.getHours()-h);
        return this;
    }

    let veranstaltungDate;
    if (event.startzeit) {
        veranstaltungDate = new Date(event.startdatum + 'T' + event.startzeit);
        veranstaltungDate.subHours(4);
    } else {
        veranstaltungDate = new Date(event.startdatum + 'T00:00:00');
    }

    let now = new Date();

    let dateWithTimeInFuture = false;


    /* ist die anmeldefrist in der zukunft? */
    if (anmeldefristDate && anmeldefristDate.getTime() > now.getTime()) {
        anmeldefristInFuture = true;
    }

    /* veranstaltung in der zukunft? */
    if (veranstaltungDate.getTime() > now.getTime()) {
        dateWithTimeInFuture = true;
    }

    let buttonName = 'Anmelden';
    if (event.status === 4) {
        buttonName = 'Anmelden Warteliste';
    }

    //console.log(dateWithTimeInFuture, anmeldefristInFuture)

    if (event.anmeldung_online === -1 && anmeldefristInFuture && dateWithTimeInFuture) {
        return <div>
            <hr />
            <a className={'btn btn-success btn-lg pull-right btn-termine-anmeldung'} target={'_blank'} href={anmeldungUrl}>{buttonName}</a>
        </div>
    }
    if (event.anmeldung_online === -1) {
        return <div>
            <hr />
            <div class="text-center">Anmeldung nicht mehr möglich</div>
        </div>
    }

    return null
}

let Share = (props) => {
    let event = props.event;
    let domain = 'https://www.bildung-beratung-bayern.de';
    let shareImageDomain = 'https://www.bayerischerbauernverband.de';
    let shareUrl = domain+'/?tid='+event.id;
    let titel = event.titel;
    return <div style={{ fontSize: '12px'}}>
        <div className={"social-share-buttons--mobile"}>
            <a href={"https://x.com/share?url="+shareUrl+"&via=bayernsbauern&text="+titel}><img className={"social-icon-mobile"} src={shareImageDomain+"/themes/custom/bbv/icons/twitter.svg"} alt={"Auf X/Twitter teilen"} /></a>
            <a href={"https://www.facebook.com/sharer.php?u="+shareUrl} target={"_blank"}><img className={"social-icon-mobile"} src={shareImageDomain+"/themes/custom/bbv/icons/facebook.svg"} alt={"Auf Facebook teilen"} /></a>
            <a href={"fb-messenger://share?link="+shareUrl}><img className={"social-icon-mobile"} src={shareImageDomain+"/themes/custom/bbv/icons/messenger.svg"} alt="Mit Facebook Messenger verschicken" /></a>
            <a href={"whatsapp://send?text=Schau%20mal%2C%20eine%20interessante%20Veranstaltung%20bei%20Bildung%20Beratung%20Bayern%3A%0A"+titel+"%0A"+shareUrl}><img className={"social-icon-mobile"} src={shareImageDomain+"/themes/custom/bbv/icons/whatsapp.svg"} alt={"Mit Whatsapp teilen"} /></a>
            <a href={"mailto:?Subject=Link-Tipp%20Termin&Body=Hallo%2C%20ich%20habe%20diese%20interessante%20Veranstaltung%20bei%20Bildung%20Beratung%20Bayern%20gefunden%3A%0A%0A"+titel+"%0D%0A%0D%0A"+shareUrl} target={"_blank"}><img className={"social-icon-mobile"} src={shareImageDomain+"/themes/custom/bbv/icons/mail.svg"} alt={"Mailen"} /></a>
        </div>

        <div className={"social-share-buttons--desktop"}>
            <a className={"sctw"} style={{width: '30%'}} href={"https://x.com/share?url="+shareUrl+"&via=bayernsbauern&text="+titel} target={"_blank"}><img className={"social-icon-desktop"} src={shareImageDomain+"/themes/custom/bbv/icons/twitter.svg"} alt={"Auf X/Twitte teilen"} /><span>X/Twitter</span></a>
            <a className={"scfb"} style={{width: '33%'}} href={"https://www.facebook.com/sharer.php?u="+shareUrl} target={"_blank"}><img className={"social-icon-desktop"} src={shareImageDomain+"/themes/custom/bbv/icons/facebook.svg"} alt={"Auf Facebook teilen"} /><span>Facebook</span></a>
            <a className={"scmail"} style={{width: '30%'}} href={"mailto:?Subject=Link-Tipp%20Termin&Body=Hallo%2C%20ich%20habe%20diese%20interessante%20Veranstaltung%20bei%20Bildung%20Beratung%20Bayern%20gefunden%3A%0A%0A"+titel+"%0D%0A%0D%0A"+shareUrl} target={"_blank"}><img className={"social-icon-desktop"} src={shareImageDomain+"/themes/custom/bbv/icons/mail.svg"} alt={"Mailen"} /><span>Mail</span></a>
        </div>
    </div>
}

// Main Col
let Bemerkung = (props) => {
    let event = props.event

    if (!event.bemerkung){
        return null
    }
    return <div>
        <div className={'vsp-2'} />
        <div className="alert alert-warning" role="alert">
            <strong>Hinweis: </strong>
            {
                event.bemerkung
                    .split("\n")
                    .map((row, i) => <p key={i}>{row}</p>)
            }
        </div>
    </div>
}

let Themen = (props) => {
    let event = props.event;
    let themen = event.themen;

    if (themen.length === 0){
        return null
    }

    return <div>
        {themaHeadline(event)}
        <div className={'v-themen'}>
            {themen.map(
                thema => <div className={'v-thema'}>
                    <Thema event={event} thema={thema} />
                    <Referenten referenten={event.referenten[thema.id]}/>
                </div>
            )
            }
        </div>
    </div>
}

let Thema = (props) => {
    let event = props.event;
    let thema = props.thema;

    if (thema.name !== event.titel && thema.ziel !== event.ziel) {
        return <div className={'v-thema-detail'}>
            <h3>{thema.name}</h3>
            <p>{thema.ziel}</p>
        </div>
    }

    if (thema.name !== event.titel && thema.ziel === event.ziel) {
        return <div className={'v-thema-detail'}>
            <h3>{thema.name}</h3>
        </div>
    }

    return null;
}

let Referenten = (props) => {
    let referenten = props.referenten;

    if (!referenten){
        return null
    }

    if (referenten.length === 0){
        return null
    }

    let headline = 'Referenten:'
    if (referenten.length === 1) {
        headline = 'Referent/in:'
    }

    return <div>
        <h3>{headline}</h3>
        <div className={'v-referenten'}>
            {referenten.map(
                referent => <div className={'v-referent'}>
                    {referent.anrede} {referent.titel && <span>{referent.titel} </span>}
                    {referent.vorname} {referent.nachname}
                    {referent.organisation && <span> ({referent.organisation})</span>}
                    {referent.funktion && <span><br /><small>{referent.funktion} </small></span>}
                    {referent.qualifikation && <span><br /><small>Qualifikation: {referent.qualifikation}</small></span>}
                </div>
                )
            }
        </div>
    </div>
}

let Bilder = (props) => {
    let images = props.event.images

    if (images.length === 0) {
        return null
    }

    return <div>
        <hr />
        <div className={'vsp-2'} />
        <h2>Bilder zu dieser Veranstaltung</h2>
        {images.map(
            image => <div className={'media--image-frame mif-modal'}>
                <span className={'ov-copyright'}>&copy; {image.copyright}</span>
                <div className={'v-image'}>
                    <img src={config.baseUrl+image.path} alt={image.alt} />
                </div>
            </div>
        )
        }
        <div className={'vsp-2'} />
    </div>
}

let Dokumente = (props) => {
    let documents = props.event.documents

    if (documents.length === 0) {
        return null
    }

    return <div>
        <hr />
        <div className={'vsp-2'} />
        <h2>Dokumente zu dieser Veranstaltung</h2>
        {documents.map(
            document => <div>
                <div className={'v-image'}>
                    <a href={config.baseUrl+document.path} target={'_blank'} className={'btn btn-success'}>
                        <nobr>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-pdf" viewBox="0 0 16 16" style={{'display': 'inline'}}>
                              <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
                              <path d="M4.603 12.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.701 19.701 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.716 5.716 0 0 1-.911-.95 11.642 11.642 0 0 0-1.997.406 11.311 11.311 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.27.27 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.647 12.647 0 0 1 1.01-.193 11.666 11.666 0 0 1-.51-.858 20.741 20.741 0 0 1-.5 1.05zm2.446.45c.15.162.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.881 3.881 0 0 0-.612-.053zM8.078 5.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>
                            </svg>
                            <span>&nbsp;{document.titel}</span>
                        </nobr>
                    </a>
                </div>
            </div>
        )
        }
        <div className={'vsp-2'} />
    </div>
}

function themaHeadline(event)  {
    let themen = event.themen;
    let themenLength = themen.length;

    themen.forEach((thema) => {
       if (thema.name === event.titel) {
           themenLength = themenLength-1;
       }
    });

    if (themenLength > 1) {
        return <div>
            <hr />
            <h2>Themen:</h2>
        </div>
    }

    if (themenLength === 1) {
        return <div>
            <hr />
            <h2>Thema:</h2>
        </div>
    }
    return null
}

class TerminDetail extends Component{

    render(){
        let {event} = this.props;

        return <div className={'row'}>
            <div className={'col-sm-12 col-md-8'}>
                <div className={'title-bar'}><h2>{event.fachgebiet}</h2></div>
                <div className={'vsp-2'} />
                <div className={'article-body'}>
                    <h1>{nl2br(event.titel)}</h1>
                    <div className={'vsp-2'} />
                    <div className={'content-teaser'}>{nl2br(event.ziel)}</div>
                    <Bemerkung event={event} />
                    <Themen event={event}/>
                    <Dokumente event={event}/>
                    <Bilder event={event}/>
                </div>
            </div>
            <div className={'col-sm-12 col-md-4'}>
                <div className={'block-dark'} style={{ fontSize: '15px'}}>
                    <div className={'tab-content p-4'}>
                        <div><strong>Termin:</strong></div>
                        <DateFromTo event={event} />
                        <TimeFromTo event={event} />
                        <Teilnehmer event={event} />
                        <SigninDeadline event={event} />
                        {event.format !== null && event.format !== 1 ? <div>Format: { event.format }</div> : <span /> }
                        {event.status === 2 ? <div className={'alert alert-danger'} style={{textAlign: 'center'}}>Abgesagt</div> : <span /> }
                        {event.status === 4 ? <div className={'alert alert-danger'} style={{textAlign: 'center'}}>Ausgebucht</div> : <span /> }
                        <Ansprechpartner kreisverband={event.kreisverband} />
                        <Veranstaltungsort raum={event.raum}/>
                        <Gebuehr event={event} />
                        <Anmeldung event={event} />
                        <Share event={event} />
                        <div><small><u>https://www.bildung-beratung-bayern.de/?tid={event.id}</u></small></div>
                        <div className={'clearfix'} />
                        <div className={'vsp-2'} />
                    </div>
                </div>
            </div>
        </div>
    }
}


export default TerminDetail



// WEBPACK FOOTER //
// ./src/components/TerminDetail.js